import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import Hotspot = Vertica.LouisPoulsen.Application.Content.Blocks.ProductHotspotViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageWithProductHotspots',
  props: {
    cssClasses: { default: '' },
    image: null,
    sizes: { default: () => ['600'] },
    widths: { default: null },
    format: { default: 'jpg' }
  },
  setup(__props: any) {

const props = __props as { cssClasses: string, image: ImageWithProductHotspotsViewObject, sizes: string[], widths: string[] | null, format: string }



function uid(index: number) { return Symbol(`image-hotspot-${index}`); }

const selectedHotspot = ref<Hotspot | null>(null);
const showErrorImage = ref<boolean>(false);
const showModal = ref<boolean>(false);

const widthsValue = props.widths || props.sizes;

function iconColor(hotspot: Hotspot) {
    return hotspot.iconColor || 'white';
}

function toggleHotspot(event: Event, hotspot: Hotspot) {
    event.preventDefault();
    event.stopPropagation();
    selectedHotspot.value = hotspot;
    showModal.value = true;
};

function closeModal() {
    showModal.value = false;
    showErrorImage.value = false;
}

return { __sfc: true,props, uid, selectedHotspot, showErrorImage, showModal, widthsValue, iconColor, toggleHotspot, closeModal }
}

})